import AppDetailHeader from "../Headers/AppDetailHeader";
import AppDetailTabs from "../Tabs/AppDetail/AppDetailTabs";
import { CloudApp, GlobalApp } from "../../../types/GlobalInterfaces";
import NotFoundView from "../../../layouts/SharedViewLayout/NotFoundView";

interface Props {
  app: GlobalApp | CloudApp;
  isAdmin: boolean;
}

const AppDetail = ({ app, isAdmin }: Props) => {
  if (!app) {
    return (
      <div className="tw:w-full tw:h-full mt--8 mb--6">
        <NotFoundView />
      </div>
    );
  }

  return (
    <div className="tw:flex tw:flex-col tw:sm:px-4 tw:md:px-8 tw:w-full tw:max-w-6xl">
      <AppDetailHeader app={app} isAdmin={isAdmin} />
      <AppDetailTabs app={app} />
    </div>
  );
};

export default AppDetail;
